import { Injectable } from '@angular/core';
import { isObject } from '../utils/helpers';
import { TranslateService } from '@ngx-translate/core';

export interface SkyErrorMessages {
    [key: string]: string | any;
}

@Injectable()
export class StyErrorMessagesService {
    constructor(public translate: TranslateService) {}

    public errorMessages: SkyErrorMessages = {};

    public getErrorMessageByCode(code: string | number, errorMessages = this.errorMessages) {
        for (const key in errorMessages) {
            if (key === code) {
                return this.translate.instant(this.errorMessages[key]);
            } else {
                if (isObject(errorMessages[code])) {
                    return this.getErrorMessageByCode(code, errorMessages[code]);
                } else {
                    return null;
                }
            }
        }
    }
}
